module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer2_offgrid_no-inverter 1.590ed947.svg";